// extracted by mini-css-extract-plugin
module.exports = {"backGround":"Template_backGround__3uGLx","backGroundGray":"Template_backGroundGray__1kp4q"};